import { useState } from 'react';
import Menu from '../SharedComponents/Menu';
import ham from "../Images/icons/svgIcon/hamburger.svg";
import useWindowDimensions from "../Screen Size";

const MainLayout = (props) => {

  const [hamburger, sethamburger] = useState(false);

  const { width } = useWindowDimensions();

  const openMenu = () => sethamburger(true);
  const closeMenu = () => sethamburger(false);

  return (
    <>
      <div className="container-fluid">
        <div className="menu-container">
          {width < 768 ? (
            <div className="hamburger" onClick={openMenu}>
              <div className={hamburger ? "menuOpen" : "menuClose"}>
                <Menu />
              </div>
              <img className={(hamburger ? "d-none" : "") + " menuIcon"} src={ham} onClick={openMenu} />
            </div>
          ) : (
            <div className="leftMenu">
              <Menu />
            </div>
          )}
        </div>
        <div
          className="mainContent"
          onClick={closeMenu}>
          {props.children}
        </div>
      </div>
    </>
  );
};

export default MainLayout